import { GQL } from "./GQL"
import { MUTATION_UPDATE_CONTRIBUTION } from "./mutations"

export function updateActiveContribution(
  organizationId: string,
  active: boolean
) {
  const input = { organizationId, active }
  return GQL.request<UpdateActiveContributionResponse>(
    MUTATION_UPDATE_CONTRIBUTION,
    { input }
  )
}
